import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CustomRadioButton from '../common/CustomRadioButton';
import ActionButton from '../common/Action Buttons/ActionButton';
import ActionButton2 from '../common/Action Buttons/ActionButton2';
import {uploadDocument} from '../../api/network/documentService';
import {roles} from '../../utils/auth';
import SignatureComponent from '../common/SignatureComponent';
import CustomFileInput from '../common/CustomFileInput';
import CustomInputField from '../common/CustomInputField';
import Label1 from '../common/Label1';


const DialogAction = styled.div`
    width: 100%;
    height: fit-content;
    
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    
     > * {
      margin-right: 24px;
    }
`;

const DialogSubHead = styled.span`
    color: var(--color-black);
    margin-bottom: 44px;
`;


const DialogForm = styled.span`
    color: var(--color-black);
    margin-bottom: 44px;
`;

const CustomStyledInput = styled.input`
    color: transparent; 
    outline: 0;
    height: 33px;
    width: var(--government-id-width);

    > div {
      width: fit-content;
    }
    &::-webkit-file-upload-button {
      visibility: hidden;
    }
    &::before {
      width: calc(100% - 0.125rem);
      text-align: center;
      content: 'Upload Devlivery Slip';
      color: var(--accent-text);
      display: inline-block;
      border: 1px solid var(--accent);
      border-radius: var(--space-xs);
      padding: var(--space-s) 0;
      outline: none;
      white-space: nowrap;
      -webkit-user-select: none;
      cursor: pointer;
      font-weight: 500;
      font-size: var(--font-xs);
      transition: 0.2s background-color ease-in;
    }
    &:hover::before {
      background-color: var(--gray-secondary);
    }
    &:active {
      outline: 0;
      &::before {
      }
    }
    &:disabled::before {
      background-color: rgba(118,118,117,0.28);
    }
`;

const DialogInputWrapper = styled.div`
    flex: 1;
    flex-direction: row;
    display: flex;    
`;

const DialogInputLabel = styled.span`
    color: var(--color-black);
    margin-right: 12px;
    margin-left: 32px;
    align-self: center;
`;

/**
 *
 * @param showDialog
 * @param id
 * @param companyName
 * @param setInvoiceDocument
 * @param onSubmitClick
 * @param onCloseClick
 * @param onDialogClose
 * @param role
 * @param setSignatureRef
 * @returns {*}
 * @constructor
 */
const ContractDeliveryDialog = ({showDialog, id, companyName, setInvoiceDocument, onSubmitClick, onCloseClick, onDialogClose, role, setSignatureRef}) => {
    const [radioOption, setRadioOption] = useState('physical');
    const [canSubmitSignature, setCanSubmitSignature] = useState(false);
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [isFile, setIsFile] = useState(false);

    const handleOnRadioChange = e => {
        const {value} = e.target;
        setRadioOption(value);
    };

    const onFileChange = e => {
        if (e) e.preventDefault();
        const file = e.target.files[0];
        if (file) setIsFile(true);
        setInvoiceDocument(file);
    };

    const isCustomerRep = role === roles.CUSTOMER_REP;

    const onInvoiceInputChange = e => {
        if (!e) return;
        let {value, name} = e.target;
        value = value.trim().toUpperCase().replace(/ /g, '');
        if (value.length <= 15) setInvoiceNumber(value);
    };

    const disableSubmit = () => {
        const shouldUploadFile = (isCustomerRep ? (!canSubmitSignature && radioOption === 'digital') : (!isFile && radioOption === 'digital'));
        if (!radioOption) {
            return true;
        }
        if (shouldUploadFile) {
            return true;
        }
        return !invoiceNumber && !isCustomerRep;
    };

    const handleOnSubmitClick = () => onSubmitClick(invoiceNumber);

    return (
        <Dialog
            open={showDialog}
            keepMounted
            onClose={onDialogClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">
                {`Contract ${id} - Delivery Alert`}
                <hr style={{
                    border: '.5px solid var(--color-black)',
                    width: '100%',
                }}
                />
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {
                        isCustomerRep ? (
                            <DialogSubHead>
                                Complete delivery process by signing the accompanying delivery slip.
                            </DialogSubHead>
                        ) : (
                            <DialogSubHead>
                                {`Alert ${companyName} representatives to expect delivery of devices within the next 48 hours for contract `}
                                {<span style={{color: 'var(--color-blue-600)'}}>{id}</span>}.
                            </DialogSubHead>
                        )}
                </DialogContentText>

                <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    value={radioOption}
                    onChange={handleOnRadioChange}
                >
                    <DialogForm>


                        <FormControlLabel
                            value="physical"
                            label={isCustomerRep ?
                                'Printed delivery slip, signed and returned to courier' :
                                'Include printed delivery slip with courier'
                            }
                            control={<CustomRadioButton color="primary"/>}
                            labelPlacement="end"
                        />


                        <FormControlLabel
                            value="digital"
                            control={<CustomRadioButton color="primary"/>}
                            label={isCustomerRep ?
                                'Sign delivery slip digitally in the space provided' :
                                'Include digital delivery slip with an Alert (auto generated)'
                            }
                            labelPlacement="end"
                        />

                        {
                            isCustomerRep && radioOption === 'digital' &&
                            <SignatureComponent
                                width={560}
                                setRef={setSignatureRef}
                                onSignatureBegin={() => setCanSubmitSignature(false)}
                                onSignatureEnd={() => setCanSubmitSignature(true)}
                            />
                        }

                        {
                            !isCustomerRep &&

                            <FormControl style={{flex: '1', marginTop: '20px'}}>
                                <DialogInputWrapper>
                                    <DialogInputLabel> Invoice Number for order: </DialogInputLabel>
                                    <CustomInputField
                                        color="primary"
                                        name="invoiceNumber"
                                        value={invoiceNumber}
                                        onChange={onInvoiceInputChange}
                                        placeholder="SMS-000000"
                                    />
                                </DialogInputWrapper>

                            </FormControl>

                        }
                    </DialogForm>
                </RadioGroup>
            </DialogContent>


            <DialogAction>
                <ActionButton
                    onClick={handleOnSubmitClick}
                    disabled={disableSubmit()}
                    color="primary"
                >
                    Submit
                </ActionButton>
                {
                    !isCustomerRep && radioOption === 'digital' &&
                    <CustomStyledInput
                        disabled={!radioOption || (radioOption && radioOption === 'start')}
                        type="file"
                        accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .pdf, app/msword, app/vnd.ms-excel, app/vnd.ms-powerpoint, text/plain, app/pdf, image/*"
                        onChange={onFileChange}
                    />
                }
                <ActionButton2 onClick={onCloseClick} color="primary">
                    Cancel
                </ActionButton2>
            </DialogAction>
        </Dialog>
    );
};

ContractDeliveryDialog.propTypes = {};
ContractDeliveryDialog.defaultProps = {contract: {}};

export default ContractDeliveryDialog;
